/**
 * Enum Loại tổng hợp dự toán
 * NMDUC1 6.7.2022
 */
export default {
  ReceiptBudget: 0,
  ReceiptActivity: 1,
  PaymentBudget: 2,
  PaymentActivity: 3,
};
